import { render } from "./UserTile.vue?vue&type=template&id=7add8c6a&scoped=true"
import script from "./UserTile.vue?vue&type=script&lang=js"
export * from "./UserTile.vue?vue&type=script&lang=js"

import "./UserTile.vue?vue&type=style&index=0&id=7add8c6a&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7add8c6a"]])

export default __exports__